/* libs */
import React from "react";
import { SortableContainer } from "react-sortable-hoc";

/* components */
import SortableItem from "./SortableItem";

const SortableList = SortableContainer(({ children, shouldDisable }) => {
	return (
		<ul className="sortable-container">
			{children &&
				children.map((item, index) => (
					<SortableItem disabled={shouldDisable} render={item} key={`item-${index}`} index={index} />
				))}
		</ul>
	);
});

export default SortableList;
